import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import useAppState from './useAppState';

export default function useActiveTimestamp() {
  const appState = useAppState();

  const [timestamp, setTimestamp] = useState<string | null>(() =>
    DateTime.local().toISO(),
  );

  useEffect(() => {
    if (appState === 'inactive' || appState === 'background') {
      setTimestamp(null);
    } else {
      setTimestamp(DateTime.local().toISO());
    }
  }, [appState]);

  return timestamp;
}
